import { initializeApp } from 'firebase/app'
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  GoogleAuthProvider,
} from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// The "Encore Web" app registered against the `encoretouring` project — the
// same project the macOS and iOS apps use, which is what makes the data one
// dataset rather than three. This is the app bound to the `encoretouring`
// Hosting site.
//
// None of this is secret. A Firebase web config identifies the project; it
// grants nothing on its own. Access is decided entirely by Firestore security
// rules and Auth. Putting it in the bundle is the documented, intended thing.
const firebaseConfig = {
  apiKey: 'AIzaSyAFspqJDY1pSSiy37gWzYRHqX3d6JyU2A0',
  authDomain: 'encoretouring.firebaseapp.com',
  projectId: 'encoretouring',
  storageBucket: 'encoretouring.firebasestorage.app',
  messagingSenderId: '218069783723',
  appId: '1:218069783723:web:4e990780c1f6b5e69153ee',
  measurementId: 'G-8YY5577N3C',
}

export const app = initializeApp(firebaseConfig)

// Offline cache, shared safely across tabs. Touring means aeroplanes and
// venues with no signal; a schedule that goes blank when the wifi drops is
// worse than useless. `persistentMultipleTabManager` is what stops a second
// tab from failing to acquire the lock — the browser equivalent of the
// two-instances-fight-over-LevelDB problem the Mac app has.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
})

export const auth = getAuth(app)
export const storage = getStorage(app)

export const googleProvider = new GoogleAuthProvider()

// Survive a refresh. Without this a reload lands back on the sign-in wall.
void setPersistence(auth, browserLocalPersistence)
